<template>
    <div class="AQZX">
        <div class="title">
            <span>安全中心</span>
        </div>
        <!-- <div class="phone">
            <div class="left">
                <div>
                    <img src="@/assets/img/phone.png" style="width: 80px;height: 80px;">
                </div>
                <div class="phoneNumber">
                    <span
                        style="font-size: 22px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 500;color: #000000;">绑定手机</span>
                    <span
                        style="font-size: 20px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 400;color: #616161;">+86
                        {{ form.phone }}</span>
                </div>
            </div>
        </div> -->
        <div class="lock">
            <div class="left">
                <div>
                    <img src="@/assets/img/lock.png" style="width: 80px;height: 80px;">
                </div>
                <div class="username">
                    <span
                        style="font-size: 22px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 500;color: #000000;">修改密码</span>
                    <span
                        style="font-size: 20px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 400;color: #616161;">
                        可点击修改密码进行修改</span>
                </div>
            </div>
            <div class="right" @click="open = true">
                <span>修改</span>
            </div>
        </div>
        <!-- 添加或修改用户信息对话框 -->
        <el-dialog :visible.sync="open" width="500px" append-to-body>
            <el-form ref="form" :model="user" :rules="rules" label-width="80px" size="medium">
                <el-form-item label="旧密码" prop="oldPassword">
                    <el-input v-model="user.oldPassword" placeholder="请输入旧密码" type="password" show-password />
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-input v-model="user.newPassword" placeholder="请输入新密码" type="password" show-password />
                </el-form-item>
                <!-- <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input v-model="user.confirmPassword" placeholder="请确认新密码" type="password" show-password />
                </el-form-item> -->

            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" size="mini" @click="submit">保存</el-button>
                <el-button type="danger" size="mini" @click="close">关闭</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { getUserInfoByUserId, updateUserInfo, updateUserPwd } from "../../api/login.js";
export default {
    data() {
        const equalToPassword = (rule, value, callback) => {
            if (this.user.newPassword !== value) {
                callback(new Error("两次输入的密码不一致"));
            } else {
                callback();
            }
        };
        const pwdRegex = (rule, value, callback) => {
            let regex = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,20}');
            if (!regex.test(value)) {
                callback(new Error("密码中必须包含大小写字母、数字、特殊字符,长度在8到20位之间。"));
            } else {
                callback();
            }
        };
        return {
            open: false,
            form: {

            },
            user: {
                oldPassword: undefined,
                newPassword: undefined,
                confirmPassword: undefined
            },
            // 表单校验
            rules: {
                oldPassword: [
                    { required: true, message: "旧密码不能为空", trigger: "blur" }
                ],
                newPassword: [
                    { required: true, message: "新密码不能为空", trigger: "blur" },
                    { required: true, validator: pwdRegex, trigger: "blur" },
                    //   {
                    //   pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]){8,30}$/,
                    //   message: '密码中必须包含大小写字母、数字、特殊字符,长度在8到20位之间。',
                    //   trigger: 'blur'
                    // }
                ],
            }
        }
    },
    methods: {
        submit() {

            this.$refs["form"].validate(valid => {
                if (valid) {
                    updateUserPwd(this.user).then(response => {
                        this.$modal.msgSuccess("修改成功");
                        this.close();
                    });
                }
            });
        },
        close() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.user = {
                oldPassword: undefined,
                newPassword: undefined,
                confirmPassword: undefined
            },
                this.resetForm("form");
        },
    },
    mounted() {
        getUserInfoByUserId().then(res => {
            this.form = res.data.data
        });

    },
}
</script>

<style scoped>
.AQZX {
    box-shadow: 0px 0px 25px 4px rgba(90, 90, 90, 0.12);
    padding: 24px 30px;
    padding-bottom: 48px;
    display: flex;
    flex-direction: column;
    min-height: 600px;
}

.title {
    padding-bottom: 20px;
    font-size: 30px;
    color: #6681EA;
    border-bottom: 1px solid #6681EA;
}

.phone {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #C0C4CC;
}

.left {
    display: flex;
    align-items: center;
}

.phoneNumber {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
}

.right {
    font-size: 20px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #6681EA;
    padding: 4px 16px;
    border: 1px solid #6681EA;
    margin-right: 50px;
    border-radius: 4px;
    cursor: pointer;
}

.lock {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #C0C4CC;
}

.username {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
}

.mailbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
}

.mail {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
}
</style>